
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useRfmFrequency } from '@/modules/rfm/frequency/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.FREQUENCY.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, rfmGroupOptions, fetchRfmGroupAll, actions } = useRfmFrequency();

        onMounted(async () => {
            await fetchRfmGroupAll();
        });

        return { v$, model, rfmGroupOptions, actions };
    }
});
